module.exports = __webpack_public_path__ + "Roboto-Medium-webfont.4d9f3f9e5195e7b074bb.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/gfurtado/Projects/v2.3 (ng4 2.1 only)/Angular 4 CLI/app/src/assets/fonts/roboto/Roboto-Medium-webfont.eot
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Medium-webfont.eot
// module chunks = styles